module.exports = __webpack_public_path__ + "static/media/bank-active.813e977e.svg";